import { render, staticRenderFns } from "./CreateSubscriptionplan.vue?vue&type=template&id=454b56f3&scoped=true&"
import script from "./CreateSubscriptionplan.vue?vue&type=script&lang=js&"
export * from "./CreateSubscriptionplan.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubscriptionplan.vue?vue&type=style&index=0&id=454b56f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b56f3",
  null
  
)

export default component.exports